import { 
    getResources,
    getResourceView, 
    searchResources, 
    searchResourcesByTag, 
    saveResource, 
    getResource, 
    getResourceMeta, 
    updateResource, 
    deleteResource, 
    slicedResources, 
    getTags, 
    voteResource, 
    getResourceMoreImages,
    loadResource,
    favoriteResource } from '@/api/run'
import { 
    SET_RESOURCES_LOADING,
    SET_RESOURCES,
    SET_RESOURCE,
    SET_RESOURCES_SLICED,
    SET_RESOURCES_TAGGED,
    SET_RESOURCES_VIEW,
    CLEAR_RESOURCES_VIEW,
    SET_RESOURCES_FILTER,
    SET_RESOURCE_ACTIVE,
    SET_RESOURCE_ID,
    ADD_RESOURCE_REFERENCE,
    REMOVE_RESOURCE_REFERENCE,
    RESET_RESOURCE,
    CLEAR_RESOURCE,
    SET_RESOURCE_HTML,
    SET_TAGS,
    SET_RESOURCE_SEARCH,
    CLEAR_RESOURCE_SEARCH,
    SET_RESOURCE_SEARCH_TAG,
    SET_RESOURCE_META,
    TOGGLE_DIALOG_DETAILS,
} from './mutation-types'
import {
    GET_RESOURCE,
    GET_RESOURCES,
    GET_RESOURCES_VIEW,
    GET_RESOURCES_BY_TAG,
    SAVE_RESOURCE,
    UPDATE_RESOURCE,
    DELETE_RESOURCE,
    VOTE_RESOURCE,
    FAVORITE_RESOURCE,
    GET_RESOURCES_SLICED,
    SEARCH_RESOURCES,
    GET_TAGS,
    GET_RESOURCE_META,
    GET_RESOURCE_MORE_IMAGES,
} from './action-types'
import { router } from "../main.js"

export default {
    state: {
        isLoading: false,
        error: false,
        search: null, //keywords
        searchTag: null, //tag
        filter: {},
        all: [], //all resources
        activeResource: {},
        activeId: null,
        resourcesByView: {
            stays: null,
            goods: null,
            hosting: null,
        },
        tagged: {}, // arrays of resources by tag
        tags: [], //all tags
        meta: {},
        slices: {
            latest: [],
            featured: [],
            popular: [],
        },
        sorts: [
            { title: 'Featured', path: 'featured', icon: 'stars', prop:'featured' },
            { title: 'Popular', path: 'popular', icon: 'sentiment_satisfied_alt', prop:'countVotes' },
            { title: 'Latest', path: '', icon: 'schedule', prop:'dtCreated' }
        ],
        originalResource: null,
        dialogDetails: {
            stays: false,
            goods: false,
            hosting: false,
        },
    },
    getters: {
        restoreResource: (state) => {
            return () => state.originalResource || state.resource
        },
        featured: state => {
            return state.slices.featured.filter(p =>p.featured).slice(0,12)
        },
        latest: state => {
            return state.slices.latest.filter(p =>(p.name && !p.forkedId && p.userId.emailVerified)).slice(0,6)
        },
        popular: state => {
            return state.slices.popular.filter(p =>!p.featured).slice(0,6)
        },
        premium: state => {
            return state.slices.premium.filter(p=>p.cost>0).slice(0,24)
        },
        picks: state => {
            return state.slices.picks.filter(p=>p.cost>0).slice(0,48)
        },
        getUserPointer: () => {
            return (id) => {
                if (id && typeof id !== Object) {
                    return {
                        __type: "Pointer",
                        className:"_User",
                        objectId: id
                    }
                }
                else {
                    return id
                }
            }
        },
        currentPage: state => {
            if (state.resource.code.pages && state.resource.code.pages.length>0) {
                return state.resource.code.pages.findIndex(p => p.active)+1
            }
            else {
                return 0
            }
        },
        getActiveResource: (state) => {
            return (viewName) => {
                if (viewName && state.resourcesByView[viewName]) {
                    return state.resourcesByView[viewName].find(r => r.id === state.activeId)||{}
                }
                else {
                    return {}
                }
            
            }
        },
        getActiveResourceIndex: (state) => {
            return (viewName) => {
                if (viewName && state.resourcesByView[viewName]) {
                    return state.resourcesByView[viewName].findIndex(r => r.id === state.activeId)||0
                }
                else {
                    return -1
                }
            }
        },
    },
    mutations: {
        [SET_RESOURCES_LOADING] (state, isLoading) {
            state.isLoading = isLoading
        },
        [SET_RESOURCES] (state, all) {
            //console.log('SET_RESOURCES...', all)
            state.all = all
        },
        [SET_RESOURCES_VIEW] (state, { resources, viewName }) {
            state.resourcesByView[viewName] = (state.resourcesByView[viewName]||[]).concat(resources)
        },
        [CLEAR_RESOURCES_VIEW] (state, { viewName }) {
            state.resourcesByView[viewName] = null
        },
        [SET_RESOURCES_SLICED] (state, { resources, sortBy }) {
            switch (sortBy) {
                case '-dtCreated':
                    state.slices.latest = resources
                    break;
                case '-countVotes':
                    state.slices.popular = resources
                    break;
                case '-featured,-dtCreated':
                    state.slices.featured = resources
                    break;
                case '-cost':
                    state.slices.premium = resources
                    break;
                case '-pick':
                    state.slices.picks = resources
                    break;
                default:
                    break;
            }
        },
        [SET_RESOURCES_TAGGED] (state, { tag, resources }) {
            //console.log('SET_RESOURCES_TAGGED...', tag, resources)
            state.tagged[tag] = resources
        },
        [SET_RESOURCES_FILTER] (state, filterObj) {
            console.log('SET_RESOURCES_FILTER...', filterObj)
            if (Object.keys(filterObj).length === 0) {
                //clear filter
                state.filter = {}
            } else {
                //append filter
                state.filter = {
                    ...state.filter,
                    ...filterObj,
                }
            }
        },
        [SET_RESOURCE_ACTIVE] (state, id) {
            console.log('SET_RESOURCE_ACTIVE...', id)
            state.activeId = id
        },
        [SET_RESOURCE] (state, resource) {
            console.log('SET_RESOURCE...', resource)
            state.activeResource = resource
        },
        [SET_RESOURCE_ID] (state, id) {
            //console.log('SET_RESOURCE_ID', id)
            state.activeResource.objectId = id
        },
        [ADD_RESOURCE_REFERENCE] (state, newRef) {
            state.resource.references.push(newRef)
        },
        [REMOVE_RESOURCE_REFERENCE](state, idx) {
            state.resource.references.splice(idx, 1)
        },
        [RESET_RESOURCE] (state, resource) {
            /*  creates a shallow copy of resource that
                can be restored via restoreResource getter */
            let curr = resource
            let copy = {}
            Object.keys(curr).forEach(k => {
                if (typeof curr[k] !== Object) {
                    copy[k] = curr[k]
                }
            })
            state.originalResource = copy
        },
        [CLEAR_RESOURCE] (state) {
            /*  resets resource to defaultResource */
            //console.log('dispatched CLEAR_RESOURCE')
            let resource = {}
            state.resource = { 
                ...resource,
                // ...defaultResource,
                includes: [],
                references: []
            }
        },
        [SET_RESOURCE_SEARCH_TAG] (state, value) {
            //console.log('dispatched SET_RESOURCE_SEARCH_TAG', terms)
            state.searchTag = value
        },
        [SET_RESOURCE_SEARCH] (state, terms) {
            //console.log('dispatched SET_RESOURCE_SEARCH', terms)
            state.search = terms
        },
        [CLEAR_RESOURCE_SEARCH] (state) {
            //console.log('CLEAR_RESOURCE_SEARCH')
            state.search = null
        },
        [SET_RESOURCE_HTML] (state, {htmlDoc, objectId}) {
            //console.log('SET_RESOURCE_HTML', objectId)
            state.htmlDocs = {
                ...state.htmlDocs,
                [objectId]: htmlDoc
            };
            //state.htmlDocs[objectId] = htmlDoc
        },
        [SET_RESOURCE_META] (state, meta) {
            state.meta = meta;
        },
        [SET_TAGS] (state, tags) {
            state.tags = tags
        },
        [TOGGLE_DIALOG_DETAILS] (state, { view, value }) {
            console.log('TOGGLE_DIALOG_DETAILS', view, value)
            state.dialogDetails[view] = value
        },
    },
    actions: {
        [GET_RESOURCES]: async ({commit, state}) => {
            commit(SET_RESOURCES_LOADING, true)
            let resp = []
            try {
                if (state.search) {
                    console.log('GET_RESOURCES search')
                    resp = await searchResources(state.search)
                }
                else if (state.searchTag) {
                    console.log('GET_RESOURCES searchResourcesByTag')
                    resp = await searchResourcesByTag(state.searchTag)
                }
                else {
                    console.log('GET_RESOURCES all')
                    resp = await getResources(state.all && state.all[0]?state.all[0].offset:0)
                    // console.log('GET_RESOURCES', resp[0].offset)
                }
                commit(SET_RESOURCES, resp)
            }
            finally {
                commit(SET_RESOURCES_LOADING, false)
            }
        },
        [GET_RESOURCES_VIEW]: async ({state, commit}, { viewName, pageSize, offset }) => {
            commit(SET_RESOURCES_LOADING, true)
            console.log(viewName)
            let filter = {
                ...state.filter
            }
            console.log(filter)
            let resp = []
            try {
                resp = await getResourceView(viewName, pageSize, offset, filter)
                commit(SET_RESOURCES_VIEW, { resources: resp, viewName } )
            }
            finally {
                commit(SET_RESOURCES_LOADING, false)
            }
        },
        'LOAD_RESOURCE': async ({commit}, { remoteId, type }) => {
            try {
                let retVal = await loadResource(remoteId, type)
                console.log(retVal)
            }
            finally {
                commit(SET_RESOURCES_LOADING, false)
            }
        },
        [GET_RESOURCE_MORE_IMAGES]: async ({commit}, { id, recId }) => {
            try {
                let retVal = await getResourceMoreImages(id, recId)
                console.log(retVal)
            }
            finally {
                commit(SET_RESOURCES_LOADING, false)
            }
        },
        [GET_RESOURCES_SLICED]: async ({commit}, sortBy) => {
            commit(SET_RESOURCES_LOADING, true)
            //console.log(sortBy)
            try {
                let resources = await slicedResources(sortBy)
                commit(SET_RESOURCES_SLICED, { resources, sortBy })
            }
            finally {
                commit(SET_RESOURCES_LOADING, false)
            }
        },
        [GET_RESOURCES_BY_TAG]: async ({commit}, tag) => {
            let resp = []
            if (tag) {
                resp = await searchResourcesByTag(tag)
                commit(SET_RESOURCES_TAGGED, { tag, resources:resp })
            }    
        },
        [SEARCH_RESOURCES]: async ({commit}) => {
            commit(SET_RESOURCES_LOADING, true)
            //console.log('SEARCH_RESOURCES..')
            //TODO: find resources in db
            setTimeout(()=>{
                commit(SET_RESOURCES_LOADING, false)
            },400)
        },
        [GET_RESOURCE]: async ({state, commit, rootState}, id) => {
            //console.log('dispatched GET_RESOURCE', id)
            state.isLoading = true
            let token = rootState.user.token
            let resp = await getResource(id, token)
            if (resp.error || !resp.objectId) {
                commit('SET_ERROR', 'The resource could not be loaded')
                router.push('/404')
            }
            else {
                if (resp.editorLayout) {
                    rootState.editor.activeLayout = resp.editorLayout
                }
                commit(SET_RESOURCE, resp)
                commit(RESET_RESOURCE, resp)
            }
            state.isLoading = false
        },
        [GET_RESOURCE_META]: async ({commit}, id) => {
            
            let resp = await getResourceMeta(id)
            if (resp.error || !resp.objectId) {
                commit('SET_ERROR', 'The resource could not be loaded')
                router.push('/404')
            }
            else {
                commit(SET_RESOURCE_META, resp)
            }
        },
        [SAVE_RESOURCE]: async ({state, commit, rootState}) => {
            //console.log('dispatched SAVE_RESOURCE', state.resource)
            if (rootState.user.currentUser) {
                state.resource.username = rootState.user.currentUser.username
                state.resource.userId = {
                    __type:"Pointer",
                    className:"_User",
                    objectId:rootState.user.currentUser.objectId
                };
            }
            let resp = await saveResource(state.resource)
            if (resp.error || !resp.objectId) {
                commit('SET_ERROR', resp.error)
            }
            else {
                commit(SET_RESOURCE_ID, resp.objectId)
                commit('SET_RESOURCES_CHANGED')
            }
        },
        [UPDATE_RESOURCE]: async ({state, commit}) => {
            //console.log('dispatched UPDATE_RESOURCE', state.resource)
            let resource = {
                ...state.resource
            }

            // should never need to update user?
            delete resource.userId
            /*
            if (!state.resource.userId && rootState.user.currentUser) {
                state.resource.userId = {
                    __type:"Pointer",
                    className:"_User",
                    objectId:rootState.user.currentUser.objectId
                }
            }*/
            
            let resp = await updateResource(resource)
            if (resp.error) {
                commit('SET_ERROR', resp.error)
            }
        },
        [DELETE_RESOURCE]: async ({commit, rootState}, id) => {
            //console.log('dispatched DELETE_RESOURCE', id)
            let resp = await deleteResource(id)
            // empty resp object means success
            if (Object.keys(resp).length === 0 && resp.constructor === Object) {
                rootState.global.info = "Resource deleted"
                setTimeout(()=>{
                    rootState.global.info = null
                }, 3000)
            }
            commit('SET_RESOURCES_CHANGED')
        },
        [VOTE_RESOURCE]: async ({commit, state, rootState}, payload) => {
            //console.log('dispatched VOTE_RESOURCE', payload)
            if (rootState.user.currentUser) {
                let userId = rootState.user.currentUser.objectId
                let resp = await voteResource(payload.resourceId, userId, payload.token)
                if (resp && resp.ok) {
                    state.resource.countVotes = resp.countVotes
                    //let msg = (resp.amount === 1)?'Voted!':'Unvoted'
                    //commit('SET_INFO', msg)
                }
                else {
                    commit('SET_ERROR', 'Voting error')
                }
            }
            else {
                commit('SET_ERROR', 'Current user not found')
            }
        },
        [FAVORITE_RESOURCE]: async ({commit, rootState}, payload) => {
            //console.log('dispatched FAVORITE_RESOURCE', payload)
            if (rootState.user.currentUser) {
                let userId = rootState.user.currentUser.objectId
                let resp = await favoriteResource(payload.resourceId, userId, payload.token)
                if (resp && resp.ok) {
                    //let msg = (resp.amount === 1)?'Faved!':'Unfavorited'
                    //commit('SET_INFO', msg)
                    rootState.user.currentUser.favorites = resp.favorites
                }
                else {
                    commit('SET_ERROR', 'Favorite error')
                }
            }
            else {
                commit('SET_ERROR', 'Current user not found')
            }
        },
        [GET_TAGS]: async ({commit}) => {
            try {
                let resp = await getTags()
                commit(SET_TAGS, resp)
            }
            catch {
                //console.log('GET_TAGS error')
            }
        }
    }
}